import { render } from "./ModalPix.vue?vue&type=template&id=7f469dc8&ts=true"
import script from "./ModalPix.vue?vue&type=script&lang=ts"
export * from "./ModalPix.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__